import { Injectable, Inject, InjectionToken } from "@angular/core";
import { AuthClientConfig } from "@auth0/auth0-angular";

export const APP_CONFIG: InjectionToken<AppConfig> =
  new InjectionToken<AppConfig>("Application Configuration");

@Injectable()
export class AppConfigService {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: any,
    private authClientConfig: AuthClientConfig
  ) {
    this.authClientConfig.set({
      clientId: this.appConfig?.clientId,
      domain: this.appConfig?.domain,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: this.appConfig.authorizationParams.audience,
      },
    });
  }
}

interface AppConfig {
  auth0_audience: string;
  auth0_domain: string;
  auth0_client_id: string;
}
